"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselSlide = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _clsx = _interopRequireDefault(require("clsx"));
var _common = require("../../common");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CarouselSlide = ({
  children,
  minWidth,
  testId,
  hasFocus,
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const rootClassName = (0, _clsx.default)(_constants.SLIDE_CLASSNAME, className);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CarouselSlideRoot, {
    className: rootClassName,
    "data-testid": testId ?? getTestId(_common.CAROUSEL_SLIDE),
    minWidth: minWidth,
    tabIndex: hasFocus ? 0 : -1,
    children: children
  });
};
exports.CarouselSlide = CarouselSlide;
